<template>
  <div>
    <v-btn class="primary" @click="verifyOTP()" v-if="canVerify">{{ buttonText }}</v-btn>
    <p class="font-weight-medium" v-if="insertOTPMsg">Para poder verificar el código OTP es necesario que lo introduzca en la caja de texto.</p>
    <!-- <p class="esign-error-text" v-if="!emailInvalidMsg">Para poder verificar el código OTP el correo electrónico proporcionado tiene que tener un formato válido.</p> -->
    <p id="snackbar-success"></p>
    <p id="snackbar-error"></p>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
export default {
  props: {
    token: String,
    endPoint: String,
    domainUuid: String,
    buttonText: String,
    operationUuid: String,
    otpType: String,
    status: {
      type: Number,
      default: 0
    },
    response: {
      type: String,
      default: "Verifica un código OTP."
    },
    loading: Boolean,
    snackBar: Boolean,
    successMsg: String,
    errorMsg: String
  },
  data() {
    return {
      operationUuidMsg: false,
      otpValueMsg: false,
      optTypeMsg: false,
      domainUuidMsg: false,
      emailInvalidMsg: true,
      canVerify: true,
      data: {},
      insertOTPMsg: false
    };
  },
  created() {
    this.operationUuidMsg =
      (typeof this.operationUuid === "undefined" ||
        this.operationUuid === "") === true;
    this.domainUuidMsg =
      (typeof this.domainUuid === "undefined" || this.domainUuid === "") ===
      true;
    this.otpTypeMsg =
      (typeof this.otpType === "undefined" || this.otpType === "") === true;
    // this.emailInvalidMsg = this.isEmailValid(this.email);
    if (
      this.operationUuidMsg === true ||
      this.domainUuidMsg === true ||
      this.otpTypeMsg === true
    ) {
      this.canVerify = false;
    }
  },
  methods: {
    verifyOTP() {
      this.data.operationUuid = this.operationUuid;
      this.data.otpValue =
        typeof Vue.prototype.$otp === "undefined" || Vue.prototype.$otp === ""
          ? undefined
          : Vue.prototype.$otp;
      this.data.otpType = this.otpType;
      if (this.data.otpValue) {
        this.insertOTPMsg = false;
        axios.defaults.headers.common.Authorization = this.token;
        if (this.loading) {
          this.showLoading();
        }
        this.EventBus.$emit("notifySignatureOtpVerify", "showLoading");
        axios
          .post(`${this.endPoint}${this.operationUuid}`, this.data, {
            headers: { "Content-type": "Application/json" }
          })
          .then(
            () => {
              if (this.snackBar) {
                this.$showSnackBar("snackbar-success", this.successMsg);
              }
              if (this.loading) {
                this.hideLoading();
              }
              this.EventBus.$emit("notifyGetOtpCode", "hideLoading");
              this.EventBus.$emit(
                "successSignatureOtpVerify",
                this.otpType.toLowerCase()
              );
            },
            () => {
              if (this.loading) {
                this.hideLoading();
              }
              if (this.snackBar) {
                this.$showSnackBar("snackbar-error", this.errorMsg);
              }
              this.EventBus.$emit("notifySignatureOtpVerify", "hideLoading");
              this.EventBus.$emit(
                "errorSignatureOtpVerify",
                this.otpType.toLowerCase()
              );
            }
          );
      } else {
        this.insertOTPMsg = true;
      }
    }
  }
};
</script>
